import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrambleTextPlugin from "gsap/ScrambleTextPlugin";

gsap.registerPlugin(ScrollTrigger, ScrambleTextPlugin);

export function gsapScramble(el, duration = 1.5, startDelay = 0) {
  const finalText = el.textContent;

  const configs = {
    duration,
    delay: startDelay,
    ease: "power2.out",
    scrambleText: {
      text: finalText,
      chars: el.dataset.animateFrom,
      revealDelay: Math.min(0.8, duration * 0.5)
    }
  }

  ScrollTrigger.create({
    trigger: el.parentElement,
    start: "top 90%",
    onEnter: () => {
      gsap.to(el, configs);
    },
    onEnterBack: () => {
      gsap.to(el, configs);
    }
  });
}
